var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 7.95768C9.34514 7.95768 9.62496 8.2375 9.62496 8.58268V12.7493C9.62496 13.0945 9.34514 13.3743 8.99996 13.3743C8.65478 13.3743 8.37496 13.0945 8.37496 12.7493V8.58268C8.37496 8.2375 8.65478 7.95768 8.99996 7.95768Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4264 4.78386C9.68296 5.01478 9.70376 5.40996 9.47285 5.66653L9.46452 5.67579C9.23361 5.93235 8.83842 5.95315 8.58186 5.72224C8.32529 5.49133 8.30449 5.09615 8.5354 4.83958L8.54373 4.83032C8.77465 4.57375 9.16983 4.55295 9.4264 4.78386Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 1.29102C4.74276 1.29102 1.29163 4.74215 1.29163 8.99935C1.29163 13.2565 4.74276 16.7077 8.99996 16.7077C13.2572 16.7077 16.7083 13.2565 16.7083 8.99935C16.7083 4.74215 13.2572 1.29102 8.99996 1.29102ZM0.041626 8.99935C0.041626 4.0518 4.05241 0.0410156 8.99996 0.0410156C13.9475 0.0410156 17.9583 4.0518 17.9583 8.99935C17.9583 13.9469 13.9475 17.9577 8.99996 17.9577C4.05241 17.9577 0.041626 13.9469 0.041626 8.99935Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleInfo);
export default __webpack_public_path__ + "static/media/check-circle-info.92142d7afdf030cd5aab9d97ba8e105c.svg";
export { ForwardRef as ReactComponent };